import React, { useState, useEffect } from 'react';
import { X, AlertTriangle, Info, CheckCircle, MessageCircle, Mail, Phone } from 'lucide-react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const InfoBanner = () => {
  const [banner, setBanner] = useState(null);
  const [isVisible, setIsVisible] = useState(true);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchBanner = async () => {
      try {
        const response = await axios.get(`${API}/settings/info-banner`);
        setBanner(response.data);
      } catch (error) {
        console.error('Error fetching banner:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchBanner();
  }, []);

  if (loading || !banner || !banner.enabled || !isVisible) {
    return null;
  }

  const getTypeStyles = () => {
    switch (banner.type) {
      case 'warning':
        return {
          bg: 'bg-gradient-to-r from-amber-500 to-orange-500',
          icon: <AlertTriangle className="h-5 w-5 flex-shrink-0" />,
          text: 'text-white'
        };
      case 'success':
        return {
          bg: 'bg-gradient-to-r from-green-500 to-emerald-500',
          icon: <CheckCircle className="h-5 w-5 flex-shrink-0" />,
          text: 'text-white'
        };
      default:
        return {
          bg: 'bg-gradient-to-r from-blue-500 to-blue-600',
          icon: <Info className="h-5 w-5 flex-shrink-0" />,
          text: 'text-white'
        };
    }
  };

  const styles = getTypeStyles();

  // Parse message to add clickable links
  const renderMessage = (message) => {
    // Replace phone numbers with clickable links
    let parts = message.split(/(01573 969 69 42|doms\.pfotenexpress@gmail\.com)/g);
    
    return parts.map((part, index) => {
      if (part === '01573 969 69 42') {
        return (
          <a 
            key={index}
            href="https://wa.me/4915739696942" 
            target="_blank" 
            rel="noopener noreferrer"
            className="inline-flex items-center gap-1 font-bold underline hover:no-underline"
          >
            <MessageCircle className="h-4 w-4" />
            {part}
          </a>
        );
      }
      if (part === 'doms.pfotenexpress@gmail.com') {
        return (
          <a 
            key={index}
            href="mailto:doms.pfotenexpress@gmail.com" 
            className="inline-flex items-center gap-1 font-bold underline hover:no-underline"
          >
            <Mail className="h-4 w-4" />
            {part}
          </a>
        );
      }
      return part;
    });
  };

  return (
    <div className={`${styles.bg} ${styles.text} px-4 py-3 relative z-[60]`}>
      <div className="max-w-7xl mx-auto flex items-start gap-3">
        {styles.icon}
        <p className="text-sm md:text-base flex-1 leading-relaxed pr-8">
          {renderMessage(banner.message)}
        </p>
        <button
          onClick={() => setIsVisible(false)}
          className="p-1 hover:bg-white/20 rounded-full transition-colors flex-shrink-0 absolute right-4 top-1/2 -translate-y-1/2"
          aria-label="Banner schließen"
        >
          <X className="h-5 w-5" />
        </button>
      </div>
    </div>
  );
};

export default InfoBanner;
